import { createContext } from 'react';

import { ValidatorResponse } from '../Utils/types/ValidatorResponse.ts';
import { LagNavn } from '../Utils/types/DimensjoneringTypes.ts';

export type ErrorsMaps = Map<LagNavn, ('tykkelseMM' | 'materiale')[]>[];
export type AddListOfErrorsParams = {
	listOfErrors: Pick<ValidatorResponse, 'inputError'>[];
	index: number;
};

export type InputErrorContextType = {
	errors: ErrorsMaps;
	resetErrors: () => void;
	getErrorForField: (field: LagNavn, index: number) => ('tykkelseMM' | 'materiale')[] | undefined;
	updateListOfErrors: (params: AddListOfErrorsParams) => void;
};

export const InputErrorContext = createContext<InputErrorContextType>({
	errors: [],
	resetErrors: () => undefined,
	getErrorForField: () => undefined,
	updateListOfErrors: () => undefined,
});
